/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmPermissionsResponse
 */
export interface ConfirmPermissionsResponse {
    /**
     * 
     * @type {string}
     * @memberof ConfirmPermissionsResponse
     */
    ticketId: string;
}

export function ConfirmPermissionsResponseFromJSON(json: any): ConfirmPermissionsResponse {
    return ConfirmPermissionsResponseFromJSONTyped(json, false);
}

export function ConfirmPermissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmPermissionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ticketId': json['ticketId'],
    };
}

export function ConfirmPermissionsResponseToJSON(value?: ConfirmPermissionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ticketId': value.ticketId,
    };
}


